import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  changeHasAddedEval,
  clearAll,
  clearResetBot,
  onGetCertificates,
  setCertificateDetails,
  setErrorMessageNotapUser,
  setLoadingNotapUser,
  showCertificateFormFunc,
} from "../../../../config/redux/slice/notapUserSlice";
import { certicatesDatatable as NotapCerticatesDatatable } from "../../../../helpers/dataTables";
import { postRequest } from "../../../../helpers/request";
import { appApi } from "../../../../utils/endpoints/appApi";
import { appUrls } from "../../../../utils/urls/appUrls";
import { CertificateWrapper, DataTableWrapper } from "../../../components";
import CertificateFilter from "../CertificateFilter";
import CertificateUploadForm from "./CertificateUploadForm";
import CertificateVerificationUploadForm from "./CertificateUploadForm";
import {
  setCertificateDetailsGeneral,
  setIsRefreshed,
  showCommentFormFunc,
} from "../../../../config/redux/slice/appSlice";
import AddCommentDrawer from "./AddCommentDrawer";
import { notap_user_roles } from "../../../../constants/english";

export default function NotapCertificateManagement() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { currencies } = useSelector((state) => state.app);

  const {
    notapUserLoading,
    notapUserErrorMsg,
    notapUserSuccessMsg,
    certificateManagement: { certificatesData, newData, showCertificateForm },
  } = useSelector((state) => state.notapUser);

  const {
    token,
    userData: { user_role },
  } = useSelector((state) => state.authData);

  useEffect(() => {
    dispatch(clearAll({}));

    dispatch(changeHasAddedEval());

    dispatch(setCertificateDetails({ details: "", modal: false }));

    NotapCerticatesDatatable(
      certificatesData,
      setDetails,
      currencies,
      "NotapCertificatesTable",
      "notap"
    );
    getAllCertificates();
  }, []);

  const getAllCertificates = async () => {
    dispatch(clearAll({}));
    const data = {
      certificate_date: "0",
      issuer: "0",
      // verification_status: notap_user_roles.includes(user_role.toLowerCase()) ? 'pending' : 'all'
      verification_status: "all",
    };
    const res = await postRequest(
      token,
      `${appApi.getCertificates}`,
      data,
      dispatch,
      setLoadingNotapUser,
      onGetCertificates,
      setErrorMessageNotapUser
    );
    //   if(res !== undefined && res.status < 400){
    //       setBanks(res.data.data)
    //   }
  };

  const setDetails = (data, type) => {
    dispatch(setIsRefreshed());
    dispatch(setCertificateDetails({ details: data, modal: true }));
    dispatch(setCertificateDetailsGeneral({ details: data, modal: true }));
    if (type === "view-details") {
      navigate(appUrls.notap_certificates_view);
    } else if (type === "eval-history") {
      navigate(
        `/notap/certificates/${encodeURIComponent(
          data?.CERTIFICATE_NUMBER
        )}/evaluation-history`
      );
    }
  };

  useEffect(() => {
    if (newData) {
      NotapCerticatesDatatable(
        certificatesData,
        setDetails,
        currencies,
        "NotapCertificatesTable",
        "notap"
      );
      dispatch(clearResetBot());
    }
    if (notapUserSuccessMsg === "WHT Rate Added Successfully") {
      getAllCertificates();
    }
  }, [newData, notapUserSuccessMsg]);

  return (
    <CertificateWrapper>
      {showCertificateForm && (
        <CertificateVerificationUploadForm backdrop={showCertificateForm} />
      )}
      {/* <AddCommentDrawer/>   */}
      <CertificateFilter />
      <DataTableWrapper
        //   tableButtons={
        //   userData?.isAdmin == false ? <AddCertificateButton/> :
        //   null
        // }
        tableID="NotapCertificatesTable"
        tableName="Certificate Management"
      >
        <thead>
          <tr>
            <th>Reference ID</th>
            <th>Certificate Number</th>
            {/* <th>Certificate Issue Date</th>
          <th>Certificate Expiry Date</th>
          <th>Certificate Effective Date</th> */}
            {/* <th>Currency</th> */}
            <th>Total Amount</th>
            <th>Amount Requested</th>
            <th>Approved Amount</th>
            <th>WHT Rate</th>
            <th>Amount Available</th>
            <th>Balance</th>
            <th>Swift No</th>
            <th>Certificate Issue Date</th>
            <th>Certificate Expiry Date</th>
            <th>Certificate Effective Date</th>
            {/* <th>Comment</th> */}
            <th>Status</th>
            <th>Currency</th>
            <th>Date</th>
            <th width={"9%"} data-orderable="false">
              Action
            </th>
          </tr>
        </thead>
        <tbody></tbody>
      </DataTableWrapper>
    </CertificateWrapper>
  );
}

function AddCertificateButton() {
  const dispatch = useDispatch();
  return (
    <div>
      <button
        onClick={() => dispatch(showCertificateFormFunc({ modal: true }))}
        className="btn btn-sm btn-outline-primary"
      >
        <i
          style={{ fontSize: "1rem" }}
          className="mdi mdi-plus-circle mr-1"
        ></i>
        Upload Certificate
      </button>
    </div>
  );
}
